import React from 'react';
import { FormConfigProps } from '../../../constants/constants';
import { hasTruthyValue } from '../../../functions/validation';
import { OTHER_TOGGLE } from '../../OtherInputItem';

export type FieldDataRecord = {
  [key: string]: string | boolean | FieldDataRecord;
};

export type PreviewDataProps = {
  fieldsData: FieldDataRecord;
  fieldsConfig: Record<string, FormConfigProps>;
};

export const PreviewNestedData = ({
  fieldsData,
  fieldsConfig,
}: PreviewDataProps) => {
  const previewDataList = Object.entries(fieldsData);

  const PreviewDataPairs = previewDataList
    .filter(([key, value]) => key !== OTHER_TOGGLE)
    .map(([key, value]) => {
      const isObject =
        typeof value === 'object' && Object.keys(value).length > 0;
      const isBoolean = typeof value === 'boolean';
      const isString = typeof value === 'string';

      const label = fieldsConfig[key]?.label;

      return (
        <React.Fragment key={key}>
          {isObject && hasTruthyValue(value) && fieldsConfig[key].children && (
            <li>
              {label}
              <PreviewNestedData
                fieldsData={value}
                fieldsConfig={fieldsConfig[key].children}
              />
            </li>
          )}
          {isBoolean && value && <li>{label}</li>}
          {isString && value && (
            <li>
              {label}
              <ul>
                <li>{value}</li>
              </ul>
            </li>
          )}
        </React.Fragment>
      );
    });
  return <ul>{PreviewDataPairs}</ul>;
};
